import * as yup from "yup";

export const validationSchemaFields = {
    skillId: yup.string().required("Insights workshop type is required.")
};

export type TalentSkillsFormValues = {
    skillId: string;
};